import './webinar-plus-corners.scss';

const WebinarPlusCorners = () => {
  return (
    <>
      <svg className="webinar-plus-corner-top-left" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path
          d="M13.7744 1.4043H7.72168C4.40805 1.40439 1.72168 4.09064 1.72168 7.4043V11.2324H0V2C1.25207e-06 0.895432 0.895431 0 2 0H13.7744V1.4043Z"
          fill="#F3E3D7"
        />
      </svg>
      <svg className="webinar-plus-corner-top-right" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path
          d="M0 1.4043H6.05273C9.36632 1.40444 12.0527 4.09068 12.0527 7.4043V11.2324H13.7744V2C13.7744 0.895432 12.879 1.84317e-08 11.7744 0H0V1.4043Z"
          fill="#F3E3D7"
        />
      </svg>
      <svg className="webinar-plus-corner-bottom-left" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path
          d="M13.7744 9.82812H7.72168C4.40805 9.82804 1.72168 7.14178 1.72168 3.82812V0H0V9.23242C1.25207e-06 10.337 0.895431 11.2324 2 11.2324H13.7744V9.82812Z"
          fill="#F3E3D7"
        />
      </svg>
      <svg className="webinar-plus-corner-bottom-right" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path
          d="M0 9.82812H6.05273C9.36632 9.82798 12.0527 7.14174 12.0527 3.82812V0H13.7744V9.23242C13.7744 10.337 12.879 11.2324 11.7744 11.2324H0V9.82812Z"
          fill="#F3E3D7"
        />
      </svg>
    </>
  );
};

export default WebinarPlusCorners;
